module.exports = __webpack_public_path__ + "img/homeTag-icon-1.59aebb97.svg";